export type Endpoints = {
  generateUrl: string;
  convertUrl: string;
  simplifyUrl: string;
};

// Centralize backend endpoints with env overrides for easy switching (Runpod/Modal/etc.)
export function getEndpoints(): Endpoints {
  const generateUrl =
    process.env.REACT_APP_GENERATE_URL ||
    // Fallbacks for existing deployments
    "https://3d-serverless-eight.vercel.app/api/trigger-s-generation";

  const convertUrl =
    process.env.REACT_APP_CONVERT_URL ||
    "https://exaflop-labs--instant3d-blender-api-fastapi-app.modal.run/api/convert-mesh";

  const simplifyUrl =
    process.env.REACT_APP_SIMPLIFY_URL ||
    "https://exaflop-labs--instant3d-blender-api-fastapi-app.modal.run/api/simplify-mesh";

  return { generateUrl, convertUrl, simplifyUrl };
}

export async function postJson<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request failed: ${res.status}`);
  }
  // Try to parse JSON; allow endpoints that return no content
  try {
    return (await res.json()) as T;
  } catch {
    return undefined as unknown as T;
  }
}

